// extracted by mini-css-extract-plugin
export var badge = "_sm-4";
export var selected = "_sm-1";
export var selectedOverlay = "_sm-5";
export var thumbnailButton = "_sm-0";
export var thumbnailFallback = "_sm-3";
export var thumbnailImage = "_sm-2";